import { render, staticRenderFns } from "./SidebarPlus.vue?vue&type=template&id=07ffe1bd&scoped=true"
import script from "./SidebarPlus.vue?vue&type=script&lang=js"
export * from "./SidebarPlus.vue?vue&type=script&lang=js"
import style1 from "./SidebarPlus.vue?vue&type=style&index=1&id=07ffe1bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ffe1bd",
  null
  
)

export default component.exports